import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '../../assets/noData.svg'
import _imports_3 from '@/assets/leftArrowFilled.svg'
import _imports_4 from '@/assets/rightArrowFilled.svg'


const _hoisted_1 = { class: "Content p-4" }
const _hoisted_2 = { class: "mainContainer" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "datacontainer"
}
const _hoisted_5 = { class: "btnposition flex flex-row-reverse gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "tableContainer" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_16 = { class: "searchRow" }
const _hoisted_17 = { class: "searchRow" }
const _hoisted_18 = { class: "searchRow" }
const _hoisted_19 = { class: "searchRow" }
const _hoisted_20 = { style: {} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["value", "disabled"]
const _hoisted_23 = {
  key: 0,
  class: "text-center"
}
const _hoisted_24 = {
  key: 1,
  class: "buttonContainer flex justify-between mt-2"
}
const _hoisted_25 = { class: "total text-black" }
const _hoisted_26 = { class: "pagecontainer flex justify-center cursor-pointer" }
const _hoisted_27 = { class: "pagination" }
const _hoisted_28 = { class: "text-black mx-2" }
const _hoisted_29 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[30] || (_cache[30] = _createElementVNode("h1", { class: "title" }, "Controls", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dummyList.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex", _ctx.sortedData.length > 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visibility = !_ctx.visibility))
                }, [
                  (_ctx.sortedData.length > 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", _hoisted_7)),
                  _cache[19] || (_cache[19] = _createTextVNode(" Filters "))
                ], 2),
                (_ctx.showAdditionalFilterArea)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btnprimary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.generateTasks()))
                    }, "Generate"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.dummyList.length != 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[25] || (_cache[25] = _createElementVNode("th", { class: "" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "checkbox",
                              disabled: ""
                            })
                          ], -1)),
                          _createElementVNode("th", {
                            class: "header cursor-pointer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('controlNumber')))
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _cache[20] || (_cache[20] = _createElementVNode("div", null, "#", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer ml-4", _ctx.className == 'controlNumber' ? _ctx.classSort : ''])
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "header cursor-pointer",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('controlTitle')))
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _cache[21] || (_cache[21] = _createElementVNode("div", null, "Title", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer ml-4", _ctx.className == 'controlTitle' ? _ctx.classSort : ''])
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "header cursor-pointer",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort('controlPriority')))
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _cache[22] || (_cache[22] = _createElementVNode("div", null, "Control Priority", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer ml-4", _ctx.className == 'controlPriority' ? _ctx.classSort : '']),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('controlPriority')))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "header cursor-pointer",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('controlClass')))
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _cache[23] || (_cache[23] = _createElementVNode("div", null, "Class", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer ml-4", _ctx.className == 'controlClass' ? _ctx.classSort : '']),
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('controlClass')))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", {
                            class: "header cursor-pointer",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sort('controlFamily')))
                          }, [
                            _createElementVNode("div", _hoisted_14, [
                              _cache[24] || (_cache[24] = _createElementVNode("div", null, "Family", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["sort cursor-pointer ml-4", _ctx.className == 'controlFamily' ? _ctx.classSort : '']),
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('controlFamily')))
                              }, null, 2)
                            ])
                          ]),
                          _cache[26] || (_cache[26] = _createElementVNode("th", null, "KPI", -1))
                        ]),
                        (_ctx.visibility)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                              _cache[27] || (_cache[27] = _createElementVNode("td", null, null, -1)),
                              _createElementVNode("td", _hoisted_16, [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "mySearch",
                                  onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filteredFunction($event.target.value, 'controlNumber')))
                                }, null, 32)
                              ]),
                              _createElementVNode("td", _hoisted_17, [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "mySearch",
                                  onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filteredFunction($event.target.value, 'controlTitle')))
                                }, null, 32)
                              ]),
                              _createElementVNode("td", _hoisted_18, [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "mySearch",
                                  onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filteredFunction($event.target.value, 'controlPriority')))
                                }, null, 32)
                              ]),
                              _createElementVNode("td", _hoisted_19, [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "mySearch",
                                  onKeyup: _cache[13] || (_cache[13] = ($event: any) => (_ctx.filteredFunction($event.target.value, 'controlClass')))
                                }, null, 32)
                              ]),
                              _createElementVNode("td", _hoisted_20, [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "mySearch",
                                  onKeyup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.filteredFunction($event.target.value, 'controlFamily')))
                                }, null, 32)
                              ]),
                              _cache[28] || (_cache[28] = _createElementVNode("td", null, null, -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.sortedData.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (rowData, rindex) => {
                              return (_openBlock(), _createElementBlock("tr", { key: rindex }, [
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    name: "checkbox",
                                    value: rowData,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedObjects) = $event)),
                                    disabled: rowData.kpis ? false : true,
                                    onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateCheckall()))
                                  }, null, 40, _hoisted_22), [
                                    [_vModelCheckbox, _ctx.selectedObjects]
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(rowData.controlNumber), 1),
                                _createElementVNode("td", null, _toDisplayString(rowData.controlTitle), 1),
                                _createElementVNode("td", null, _toDisplayString(rowData.controlPriority), 1),
                                _createElementVNode("td", null, _toDisplayString(rowData.controlClass), 1),
                                _createElementVNode("td", null, _toDisplayString(rowData.controlFamily), 1),
                                _createElementVNode("td", null, _toDisplayString(rowData.kpis ? rowData.kpis.length : '0'), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.sortedData.length == 0 && _ctx.dummyList.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[29] || (_cache[29] = [
            _createElementVNode("div", { class: "mainErrorBlock" }, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: "sssss",
                  class: "imgSizing"
                }),
                _createElementVNode("h5", { style: {"color":"#c4c4c4"} }, "You dont have any control")
              ])
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.tableBody.length > _ctx.pageSize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, "Total " + _toDisplayString(_ctx.tableBody.length), 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: _normalizeClass(["w-5 h-5 mt-0.5", _ctx.cantGoBack ? 'disabled' : '']),
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_28, _toDisplayString((this.currentPage - 1) * this.pageSize + 1) + " - " + _toDisplayString(this.currentPage * this.pageSize), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: _normalizeClass(["w-5 h-5 mt-0.5", _ctx.cantGoForward ? 'disabled' : '']),
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, null, 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}